import {Site} from "../types/Site";

// Check if the site ID is valid against the list of sites
export function isValidSiteId(sites: Site[], siteId: string | null): boolean {
  return sites.some(site => siteId === site.id.toString());
}